/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery, disable } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION : CONFIG CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
  configv2controller: {
    minHeight: pxToEm(80),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: replacePXinStringWithEM('0 4px'),
    margin: replacePXinStringWithEM('0 24px'),
    borderBottom: '2px solid #fff',
    cursor: 'pointer',
    '&.opened-true': {
      borderBottom: '2px solid #aeb6d6',
      // cursor: props => props.hideDefaultActionButtons || props.actionButtons ? 'pointer' : 'default'
    },
    '& .header': {
      display: 'flex',
      alignItems: 'center',
      gap: pxToEm(16),
      '& .title': { fontSize: pxToEm(20) }, 
      '& [fill]:not(svg)': {
        fill: '#5566AA'
      }
    },
    '& .actions': {
      display: 'flex',
      gap: pxToEm(16),
      alignItems: 'center'
    },
    '& .actionbuttons': {
      opacity: 0,
      animationName: 'fadeInUp',
      animationDelay: '.1s',
      animationDuration: '.2s',
      animationFillMode: 'forwards',
      '& .button': {
        height: pxToEm(40)
      }
    },
    '& .toggleicons': {
      '& svg': {
        width: pxToEm(30),
        height: pxToEm(30),
        '&.toggle-up': {
          cursor: 'pointer',
          '& path': { fill: '#5a74dd' }
        }
      }
    },
    '&.disabled-true': {
      '& .title': {
        extend: disable
      }
    },
    [mediaQuery.customizeThinnest]: {
      flexDirection: 'column',
      '& > *': {
        marginTop: pxToEm(16)
      },
      '& > *:last-child': {
        marginBottom: pxToEm(16)
      }
    },
    '& .button:not(:first-child)': {
      marginLeft: pxToEm(16)
    },
    '& .description': {

    },
    '& .button': {
      height: pxToEm(32),
      width: 'auto',
      padding: replacePXinStringWithEM('0 16px'),
      '& .text': {
        fontSize: pxToEm(14),
        fontWeight: 500,
        fontFamily: '"Work Sans", sans-serif;'
      }
    }
  }

});
